// @ts-nocheck
import React, { useState } from 'react'
import { useOutboundCall } from '../hooks/useOutboundCall'

/**
 * DTMFキーパッドコンポーネント
 * 通話中にダイアルトーン（DTMF）を送信するためのキーパッド
 */
export const DTMFKeypad = ({ isOpen, onClose }) => {
  const [displayValue, setDisplayValue] = useState('')
  const { sendDigits } = useOutboundCall()

  const keys = [
    { digit: '1', letters: '' },
    { digit: '2', letters: 'ABC' },
    { digit: '3', letters: 'DEF' },
    { digit: '4', letters: 'GHI' },
    { digit: '5', letters: 'JKL' },
    { digit: '6', letters: 'MNO' },
    { digit: '7', letters: 'PQRS' },
    { digit: '8', letters: 'TUV' },
    { digit: '9', letters: 'WXYZ' },
    { digit: '*', letters: '' },
    { digit: '0', letters: '+' },
    { digit: '#', letters: '' },
  ]

  const handleKeyPress = (digit) => {
    // DTMFトーンを送信
    sendDigits(digit)
    
    // ディスプレイに追加
    setDisplayValue(prev => prev + digit)
    
    // 視覚的フィードバック（ボタンのアニメーション）
    const button = document.querySelector(`[data-digit="${digit}"]`)
    if (button) {
      button.classList.add('scale-95')
      setTimeout(() => {
        button.classList.remove('scale-95')
      }, 100)
    }
  }

  const handleClear = () => {
    setDisplayValue('')
  }

  const handleBackspace = () => {
    setDisplayValue(prev => prev.slice(0, -1))
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* オーバーレイ */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
        onClick={onClose}
      />
      
      {/* キーパッド */}
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative bg-white rounded-lg shadow-xl max-w-sm w-full p-6">
          {/* ヘッダー */}
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold text-gray-900">
              ダイヤルキー
            </h3>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-500"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* ディスプレイ */}
          <div className="mb-4 bg-gray-50 rounded-lg p-4 min-h-[60px] flex items-center justify-between">
            <div className="text-2xl font-mono text-gray-900 tracking-wider flex-1">
              {displayValue || '\u00A0'}
            </div>
            {displayValue && (
              <button
                onClick={handleBackspace}
                className="ml-2 text-gray-400 hover:text-gray-600"
                title="1文字削除"
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2M3 12l6.414 6.414a2 2 0 001.414.586H19a2 2 0 002-2V7a2 2 0 00-2-2h-8.172a2 2 0 00-1.414.586L3 12z" />
                </svg>
              </button>
            )}
          </div>

          {/* キーパッドグリッド */}
          <div className="grid grid-cols-3 gap-3 mb-4">
            {keys.map(({ digit, letters }) => (
              <button
                key={digit}
                data-digit={digit}
                onClick={() => handleKeyPress(digit)}
                className="aspect-square bg-gray-100 hover:bg-gray-200 active:bg-gray-300 rounded-lg flex flex-col items-center justify-center transition-all duration-100 transform hover:scale-105"
              >
                <span className="text-2xl font-semibold text-gray-900">
                  {digit}
                </span>
                {letters && (
                  <span className="text-xs text-gray-500 mt-1">
                    {letters}
                  </span>
                )}
              </button>
            ))}
          </div>

          {/* クリアボタン */}
          {displayValue && (
            <button
              onClick={handleClear}
              className="w-full py-2 bg-red-50 text-red-600 rounded-lg hover:bg-red-100 transition-colors"
            >
              クリア
            </button>
          )}

          {/* 使い方のヒント */}
          <div className="mt-4 text-xs text-gray-500 text-center">
            キーを押すとダイヤルトーンが送信されます
          </div>
        </div>
      </div>
    </div>
  )
}
